"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
const iso7064_Mod_97_10_1 = __importDefault(require("./iso7064_Mod_97_10"));
const COUNTRY_CODES = [
    // Euro area countries
    'AT',
    'BE',
    'CY',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PT',
    'SK',
    'SI',
    'ES',
    // EU Member States with currencies other than the euro
    // Non Euro countries
    'BG',
    'HR',
    'CZ',
    'DK',
    'HU',
    'PL',
    'RO',
    'SE',
    'GB',
    // Non-EU countries
    // '??' Iceland
    'CH',
    'MC',
    'NO',
    'SM',
];
const COUNTRY_CODE_REGEXP_PATTERN = COUNTRY_CODES.join('|');
const CHECK_DIGIT_REGEXP_PATTERN = '[0-9]{2}';
const CREDITOR_BUSINESS_CODE_REGEXP_PATTERN = '[A-Z0-9]{3}';
const CREDITOR_NATIONAL_IDENTIFIER = '[A-Z0-9]{4,28}';
const BASE_ICS_REGEXP = new RegExp(`^(${COUNTRY_CODE_REGEXP_PATTERN})(${CHECK_DIGIT_REGEXP_PATTERN})(${CREDITOR_BUSINESS_CODE_REGEXP_PATTERN})(${CREDITOR_NATIONAL_IDENTIFIER})$`);
const validate = (ics) => {
    const matchResults = ics.match(BASE_ICS_REGEXP);
    if (matchResults === null) {
        return false;
    }
    const isIso7064_Mod_97_10 = iso7064_Mod_97_10_1.default(ics);
    if (isIso7064_Mod_97_10 === false) {
        return false;
    }
    const [, countryCode] = matchResults;
    switch (countryCode) {
        // TODO(Achille): Handle country specific validation
        case 'FR':
            return ics.length === 13;
        default:
            return true;
    }
};
exports.validate = validate;
